import { useState } from 'react';

export const PROPERTY_PLACEHOLDER_SRC = '/property-placeholder.png';

/**
 * Property photo with PropScope placeholder fallback at reduced opacity.
 * Real listing images render at full opacity; placeholder only uses placeholderOpacity.
 */
export default function PropertyImage({
  src,
  alt = '',
  className = 'w-full h-full object-cover',
  wrapperClassName,
  placeholderOpacity = 0.6,
  onClick,
}) {
  const [failed, setFailed] = useState(false);
  const isPlaceholder = !src || failed;

  const img = (
    <img
      src={isPlaceholder ? PROPERTY_PLACEHOLDER_SRC : src}
      alt={isPlaceholder ? '' : alt}
      className={className}
      style={isPlaceholder ? { opacity: placeholderOpacity } : undefined}
      onClick={onClick}
      onError={() => {
        if (!failed) setFailed(true);
      }}
    />
  );

  if (wrapperClassName) {
    return <div className={wrapperClassName}>{img}</div>;
  }

  return img;
}
